import axiosInstance, { ApiKeys, getApiUrl } from '@cp/src/utils/ApiHelper';
import { Dispatch } from '@reduxjs/toolkit';
import { setCallData, setCycleData, setEmiCollectedData, setPtpsOverviewMTD } from '../reducer';
import { toast } from '@navi/web-ui/lib/primitives/Toast';

export const fetchCyclesData =
  (agentRefId: string, setSelectedCycle: (value: string) => void, errorCallback?: () => void) =>
  (dispatch: Dispatch) => {
    const url = getApiUrl(ApiKeys.GET_AGENT_CYCLE_DETAILS, { agentReferenceId: agentRefId });

    axiosInstance
      .get(url)
      .then(response => {
        const cycleOptions = response.data.cycleOptions;
        dispatch(setCycleData(cycleOptions));
        setSelectedCycle(cycleOptions[0]?.value || '');
      })
      .catch(() => {
        toast.error('Failed to fetch cycle data');
        errorCallback?.();
      });
  };

export const fetchPerformanceData =
  (agentRefId: string, cycle = '', successCallback?: () => void, errorCallback?: () => void) =>
  (dispatch: Dispatch) => {
    const url = getApiUrl(ApiKeys.AGENT_DASHBOARD_DRR, {
      agentReferenceId: agentRefId,
      cycleId: cycle
    });
    axiosInstance
      .get(url, {
        headers: {
          donotHandleError: true
        }
      })
      .then(response => {
        const data = response.data;

        if (data) {
          if (data?.emiCollectedOverview) {
            dispatch(setEmiCollectedData(data.emiCollectedOverview));
          }
          if (data?.ptpOverview) {
            dispatch(setPtpsOverviewMTD(data.ptpOverview));
          }
          if (data?.callData) {
            dispatch(setCallData(data.callData));
          }
          successCallback?.();
        }
      })
      .catch(error => {
        toast.error('Failed to fetch performance data');
        errorCallback?.();
      });
  };
